import { yup } from '@framework/validation';
import { fromPairs } from 'lodash';
import { FormValidatorBuilder } from '../../../../../validator';
import { getParentValidationScope } from '../../../../../validator/utils/getParentValidationScope';
import { IWidgetType } from '../../../IWidgetType';
import { ITableInputWidget } from './ITableInputWidget';
import {
  VirtualRowCodeReferenceSuffix,
  encodeRowAsVirtualTypeValue,
} from './expression/getTableInputVirtualColumnsReferences';
import { materializeTableInputWidgets } from './expression/materializeTableInputWidget';
import { materializeTableWidgetRowPrefix } from './expression/materializeTableWidgetRowPrefix';

export const createTableSchema: IWidgetType<ITableInputWidget>['createFormSchema'] =
  ({ widget, section, page, parentScope }) => {
    const widgetScope = getParentValidationScope(widget, parentScope);
    const materializedWidgets = materializeTableInputWidgets(widget);
    return {
      ...FormValidatorBuilder.createWidgetsSchemaShape(
        materializedWidgets,
        section,
        page,
        widgetScope,
      ),
      /**
       * Materializziamo nello schema (`formvalues`) i riferimenti
       * alle _righe_ (`rowCode`), in modo che siano disponibili nelle
       * regole di valutazione.
       */
      ...createTableInputVirtualReferenceMaterializedSchemas(widget),
    };
  };

function createTableInputVirtualReferenceMaterializedSchemas(
  widget: ITableInputWidget,
) {
  return fromPairs(
    widget.rows.map((row, r) => {
      const materializedRowPrefix = materializeTableWidgetRowPrefix(
        widget,
        row,
        r,
      );
      const value = encodeRowAsVirtualTypeValue(row);
      return [
        `${materializedRowPrefix}_${VirtualRowCodeReferenceSuffix}`,
        yup
          .string()
          .notRequired()
          .default(value)
          .transform(() => value),
      ];
    }),
  );
}
